import React from 'react'
import {
  change as changeFieldValue, Field, formValueSelector, reduxForm
} from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from 'react-select';
import {cadastrarReserva} from '../../actions/reserva/actionsReserva'
import {alterarPassageiroIda} from '../../actions/passageiro/alterarPassageiroIda';
import {alterarPassageiroVolta} from '../../actions/passageiro/alterarPassageiroVolta';
import buscarPassageiroPorCpf from '../../actions/passageiro/buscarPassageiroPorCpf';
import {
  renderFieldCheck,
  renderFieldCpf,
  required,
  renderFieldDataNascimento,
  renderField,
  data,
  idadeMinCriancaColo,
  idadeMinIdoso,
  renderFieldTelefone,
  dataValidade,
  apenasNumero,
  requiredSelect,
  apenasLetra,
  minTamanhoNome,
  maxTamanhoNome,
  telefoneValidation,
  maxValueMonetario, renderFieldMonetarioLabelEncima, validarCPF, renderFieldSelect, validarRG,
  validarCPFNaoObrigatorio,
  apenasLetraComAcento,
  removerAcentos
} from '../../util/inputs';
import { paisesDDI } from '../../util/constantsUtil';

export const validate = (values) => {
  const errors = {};
  if (!values.nome) {
    errors.nome = 'Campo obrigatório'
  }
  if (!values.email) {
    errors.email = 'Campo obrigatório'
  }

  return errors
};

export class Passageiro extends React.Component {
  constructor (props) {
    super(props);
    this.limparFormulario = this.limparFormulario.bind(this);
    this.alterarTipo = this.alterarTipo.bind(this);
    this.exibirComboTipoEmissoes = this.exibirComboTipoEmissoes.bind(this);
    this.exibirComboDDI = this.exibirComboDDI.bind(this);
    this.state = { criacaoColo: false, ddi: {label: 'Brasil +55', value: 32} };
    this.handleRadio = this.handleRadio.bind(this);
  }

  componentDidMount () {
    this.atualizarValorTotalPassageiro();
  }

  componentDidUpdate (prevProps) {
    if (
      prevProps.tipoEmissao !== this.props.tipoEmissao ||
      prevProps.opcaoDescontoMeia !== this.props.opcaoDescontoMeia ||
      prevProps.passagueiroSelecionado !== this.props.passagueiroSelecionado ||
      prevProps.bloqueioPoltronasTemporario !== this.props.bloqueioPoltronasTemporario ||
      prevProps.viagemIda !== this.props.viagemIda ||
      prevProps.viagemVolta !== this.props.viagemVolta
    ) {
      this.atualizarValorTotalPassageiro();
    }
  }

  atualizarValorTotalPassageiro () {
    const resultado = this.calcularValorTotalPassageiro();
    if (resultado !== null) {
      this.props.changeFieldValue('formIncluirPassageiro', 'valorTotalPassageiro', resultado.valorCalculado);
    }
  }

  calcularValorTotalPassageiro () {
    const itinerarioPassageiro = this.pegarItinerario();
    if (!itinerarioPassageiro || !this.props.opcaoDescontoMeia) return null;

    let garantiaPreco = null;
    if (this.props.passagueiroSelecionado) {
      garantiaPreco = this.props.bloqueioPoltronasTemporario.bloqueios
        .filter(b => b.poltronaId === this.props.passagueiroSelecionado.poltronaId)[0];
    }

    let valorBase = itinerarioPassageiro.preco;
    let valorCalculado = itinerarioPassageiro.preco;

    if (this.ehEmissaoNormal()) {
      valorCalculado = itinerarioPassageiro.preco;
    } else if (this.props.ehGratuidadeTotal(this.props.tipoEmissao)) {
      valorCalculado = 0.00;
    } else if (this.props.opcaoDescontoMeia === 'EMPRESA') {
      if (this.props.ehMeiaPassagem(this.props.tipoEmissao)) {
        valorBase = garantiaPreco ? garantiaPreco.preco : itinerarioPassageiro.preco;
        valorCalculado = garantiaPreco ? garantiaPreco.precoMeia : itinerarioPassageiro.precoMeia;
      } else {
        valorCalculado = itinerarioPassageiro.preco;
      }
    } else if (this.props.ehMeiaPassagem(this.props.tipoEmissao)) {
      valorBase = garantiaPreco ? garantiaPreco.precoANTT : itinerarioPassageiro.precoANTT;
      valorCalculado = garantiaPreco ? garantiaPreco.precoANTTMeia : itinerarioPassageiro.precoANTTMeia;
    } else {
      valorCalculado = itinerarioPassageiro.precoANTT;
    }

    return { valorBase, valorCalculado, itinerarioPassageiro };
  }

  limparMensagem () {
    this.setState({ mensagem: undefined })
  }

  limparFormulario () {
    this.props.reset('formIncluirPassageiro');
    this.limparMensagem();
  }

  limpardadosCrianca () {
    this.props.changeFieldValue('formIncluirPassageiro', 'nomeCrianca', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'cpfCrianca', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'dtNascimentoCrianca', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'documentoCrianca', '');
  }

  handleExibirCamposCrianca () {
    if (this.props.criancaColo) {
      this.limpardadosCrianca()
    }
    this.props.changeFieldValue('formIncluirPassageiro', 'criancaColo', !this.props.criancaColo);
  }

  handleRadio (event) {
    this.props.changeFieldValue('formIncluirPassageiro', 'opcaoDescontoMeia', event.target.value);
  }

  exibirComboTipoEmissoes (event) {
    return (

      <div>
        <Select
          {...event.input}
          noOptionsMessage={() => ('Nenhuma opção encontrada')}
          placeholder='Adicionar um tipo...'
          options={event.tiposEmissoesSelecionados}
          onChange={(value) => {
            event.input.onChange(value);
            event.alterarTipo(value)
          }}
          onBlur={() => event.input.onBlur()}
        />
        {event.meta.touched
        && (event.meta.error && <span style={{ color: 'red' }}>{event.meta.error}</span>)}
      </div>
    )
  }

  pegarItinerario () {
    return this.props.passagueiroSelecionado && this.props.passagueiroSelecionado.sentido === 'IDA'
      ? this.props.viagemIda : this.props.viagemVolta
  }

  exibirOpcoesDescontoMeiaPassagem () {
    if (!this.props.opcaoDescontoMeiaPassagem) {
      return ''
    }
    if (this.props.tipoEmissao.value === 'ID_JOVEM_50'
      || this.props.tipoEmissao.value === 'IDOSO_50') {
      if (this.props.opcaoDescontoMeiaPassagem === 'ANTT') {
        return (
          <div className="col-sm-6 col-md-4 mt-4" onChange={this.handleRadio}>
            <input type="radio" value="ANTT" name="antt"
                   checked={this.props.opcaoDescontoMeia === 'ANTT'}/>
            Aplicar desconto no valor da ANTT
          </div>
        )
      }
      if (this.props.opcaoDescontoMeiaPassagem === 'ANTT_EMPRESA') {
        return (
          <div className="col-sm-6 col-md-4 mt-4" onChange={this.handleRadio}>
            <input type="radio" value="EMPRESA" name="empresa"
                   checked={this.props.opcaoDescontoMeia === 'EMPRESA'}/>
            Aplicar desconto no valor da Empresa
            <br/>
            <input type="radio" value="ANTT" name="antt"
                   checked={this.props.opcaoDescontoMeia === 'ANTT'}/>
            Aplicar desconto no valor da ANTT
          </div>

        )
      }
    }
    return ''
  }

  ehGratuidadeTotal() {
    if(this.props.tipoEmissao){
      const tipoEmissao = this.props.tipoEmissao.value
      return tipoEmissao === 'ID_JOVEM_100'
          || tipoEmissao === 'IDOSO_100'
          || tipoEmissao === 'DEFICIENTE'
          || tipoEmissao === 'P_LIVRE_POLICIAL_AUDITOR'
          || tipoEmissao === 'CORTESIA'
    }
    return false

  }

  ehEmissaoIdoso () {
    if (this.props.tipoEmissao === undefined) return false
    return this.props.tipoEmissao.value === 'IDOSO_100'
      || this.props.tipoEmissao.value === 'IDOSO_50'
  }

  ehEmissaoNormal () {
    if (this.props.tipoEmissao === undefined) return false
    return this.props.tipoEmissao.value === 'NORMAL'
  }

  exibirCamposAdicionaisDesconto () {
    if (this.props.tipoEmissao === undefined) {
      return ''
    }
    if (this.props.tipoEmissao.value === 'ID_JOVEM_50'
      || this.props.tipoEmissao.value === 'ID_JOVEM_100') {
      return (
        <div>
          <div className="form-row mt-1">
            <div className="col-sm-6 col-md-4">
              <Field name='nis' type="text" max={20} component={renderField}
                     label='NIS'
                     validate={[required]}
                     css="form-control"/>
            </div>
            <div className="col-sm-6 col-md-4">
              <Field name='validade' type="text" max={15} component={renderFieldDataNascimento}
                     label='Validade'
                     validate={[data, dataValidade, required]}
                     css="form-control"/>
            </div>
            {this.exibirOpcoesDescontoMeiaPassagem()}
          </div>
        </div>
      )
    }
    if (this.ehEmissaoIdoso()) {
      return (
        <div>
          <div className="form-row mt-1">
            <div className="col-sm-6 col-md-4">
              <Field name='matricula' type="text" max={80} component={renderField}
                     label='Matricula'
                     validate={[required]}
                     css="form-control"/>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="form-row">
                <div>
                  <Field name="renda" validate={[required, maxValueMonetario]}
                         component={renderFieldMonetarioLabelEncima} label="Renda R$"/>
                </div>
                {this.props.tipoEmissao.value === 'IDOSO_100'
                  ? <div>
                    <Field name='comAcompanhante' type="checkbox" component={renderFieldCheck}
                           label="Idoso com acompanhante"
                           css="form-check-input mt-2" readOnly={false}/>
                  </div>
                  : ''
                }
              </div>

            </div>
            {this.exibirOpcoesDescontoMeiaPassagem()}
          </div>
        </div>
      )
    }
    if (this.props.tipoEmissao.value === 'DEFICIENTE') {
      return (
        <div>
          <div className="form-row mt-1">
            <div className="col-sm-6 col-md-4">
              <Field name='numeroDeficiente' type="text" max={20} component={renderField}
                     label='Número'
                     validate={[required]}
                     css="form-control"/>
            </div>
            <div className="col-sm-6 col-md-4">
              <Field name='validade' type="text" max={15} component={renderFieldDataNascimento}
                     label='Validade'
                     validate={[data, dataValidade, required]}
                     css="form-control"/>
              <Field name='comAcompanhante' type="checkbox" component={renderFieldCheck}
                     label="Deficiênte com acompanhante"
                     css="form-check-input mt-2" readOnly={false}/>
            </div>
          </div>
        </div>
      )
    }
    if (this.props.tipoEmissao.value === 'P_LIVRE_POLICIAL_AUDITOR') {
      return (
        <div>
          <div className="form-row mt-1">
            <div className="col-sm-6 col-md-4">
              <Field name='cargoProfissao' type="text" max={100} component={renderField}
                     label='Cargo/Profissão'
                     validate={[required]}
                     css="form-control"/>
            </div>
          </div>
        </div>
      )
    }
    return ''
  }

  alterarTipo (tipo) {
    this.props.changeFieldValue('formIncluirPassageiro', 'tipoEmissao', tipo);
  }

  limparCamposInferiores () {
    this.props.changeFieldValue('formIncluirPassageiro', 'nomePassageiro', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'dtNascimento', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'documentoPassegeiro', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'telefone', '');
  }

  getTelefone() {
    if (this.props.seForRemarcacaoDeReservaCriadoPorUsuarioSistema || this.props.ehRemarcacao) {
      return <Field name="telefone" type="text" component={renderFieldTelefone}
                validate={[telefoneValidation]}
                css="form-control col-md-6" label="Telefone"/>
    } else {
      return <Field name="telefone" type="text" component={renderFieldTelefone}
                validate={[telefoneValidation, required]}
                css="form-control col-md-6" label="Telefone"/>
    }
  }

  getCampoEmail() {
    if(this.props.seForRemarcacaoDeReservaCriadoPorUsuarioSistema) {
      if (this.ehEmissaoIdoso() ) {
        return (
          <Field name='dtNascimento' type="text" max={10} component={renderFieldDataNascimento}
                         label='Data de nascimento'
                         validate={[data, idadeMinIdoso]}
                         css="form-control"/>
        )
      } else {
        return (
          <Field name='dtNascimento' type="text" max={10} component={renderFieldDataNascimento}
                 label='Data de nascimento' css="form-control"/>
        )
      }
    } else if (this.ehEmissaoIdoso() ) {
      return (
        <Field name='dtNascimento' type="text" max={10} component={renderFieldDataNascimento}
                       label='Data de nascimento'
                       validate={[data, idadeMinIdoso, required]}
                       css="form-control"/>
      )
    } else {
      return (
        <Field name='dtNascimento' type="text" max={10} component={renderFieldDataNascimento}
                       label='Data de nascimento'
                       validate={[required]}
                       css="form-control"/>
      )
    }
  }

  exibirComboDDI(event) {    
      return (
          <div>
              <Select
                  {...event.input}                  
                  options={paisesDDI.map(elemento => ({
                    label: `${elemento.pais} ${elemento.ddi}`,
                    value: elemento.id
                  }))}
                  onChange={(value) => {
                    event.input.onChange(value);                    
                  }}
                  onBlur={() => {}}
              />
              {event.meta.touched
              && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
        </div>
      )    
  }

  clearTelefone() {
    this.props.changeFieldValue('formIncluirPassageiro', 'telefone', '');
  }

  getCampoNome () {
    // Remarcação: nome continua obrigatório, mas passa a aceitar acentuação
    // (José, Conceição, etc.) usando apenasLetraComAcento no lugar de apenasLetra.
    // Fora da remarcação, acentos são removidos ao digitar/colar (João -> Joao).
    const ehRemarcacao = this.props.seForRemarcacaoDeReservaCriadoPorUsuarioSistema || this.props.ehRemarcacao;
    const validacaoNome = ehRemarcacao
      ? [required, apenasLetraComAcento, minTamanhoNome, maxTamanhoNome]
      : [required, apenasLetra, minTamanhoNome, maxTamanhoNome];

    return (
      <Field name='nomePassageiro' type="text" component={renderField} minLength='2' label='Nome completo'
             onChange={() => this.limparCamposInferiores()}
             normalize={ehRemarcacao ? undefined : removerAcentos}
             validate={validacaoNome}
             css="form-control" readOnly={false}/>
    )
  }

  preencherDadosPassageiro () {
    if (!this.props.passagueiroSelecionado) {
      return ''
    }
    const passageiro = this.props.passagueiroSelecionado;
    const style = {
      backgroundColor: 'rgb(250, 141, 66)',
      borderRadius: '8px',
      padding: '8px',
      width: '35px',
      textAlign: 'center',
      border: '1px solid rgb(250, 141, 66)'
    }
    
    return (
      <div className="card mb-2 p-2" key={`passageiro${passageiro.numeroPoltrona}Ida`}>
        <div className="form-row">
          <div className="col-12 col-sm-9 col-md-9">
            <strong style={style}>{passageiro.numeroPoltrona}</strong>
          </div>
          {(this.props.empresaSelecionada.habilitadoVenderCpfOpcional || !this.props.online || this.props.ehRemarcacao) ?  <><div className="col-md-4 col-sm-4">
            {!this.props.naoHabilitadoCpfPassageiro ? <Field name='cpfPassageiro' type="text" component={renderFieldCpf} label='Número do CPF'
                   validate={[validarCPFNaoObrigatorio]} onBlur={e => this.buscarUsuarioPorCpf(e)}
                   css="form-control"/> : <div style={{marginTop: '30px'}}></div>}
            <Field name='naoHabilitadoCpfPassageiro' type="checkbox" component={renderFieldCheck}
                                label="Não Possui CPF"
                                onChange={(e) => {
                                  this.props.changeFieldValue('formIncluirPassageiro', 'cpfPassageiro', '');
                                  this.props.validarPreenchimentoCpfPassageiro(e.target.checked);
                                }}
                                css='form-check-input mt-2' />
          </div></>: <div className="col-md-4 col-sm-4">
            <Field name='cpfPassageiro' type="text" component={renderFieldCpf} label='Número do CPF'
                   validate={[required, validarCPF]} onBlur={e => this.buscarUsuarioPorCpf(e)}
                   css="form-control"/>
          </div>}
          <div className="col-md-8 col-sm-8">
            {/* <Field name='nomePassageiro' type="text" component={renderField} minLength = '2' label='Nome completo' onChange={() => this.limparCamposInferiores()}
                   validate={[required, apenasLetra, minTamanhoNome, maxTamanhoNome]}
                   css="form-control" readOnly={false}/> */}
            {this.getCampoNome()}
          </div>
        </div>
        <div className="form-row mt-1">
          <div className="col-md-4 col-sm-4">
            {this.getCampoEmail()}
          </div>
          <div className="col-12 col-sm-3 col-md-3 ">
            <Field name="tipoDocumento"
                   options={this.props.tiposDocumento.map(elemento => ({
                     descricao: elemento.descricao,
                     nome: elemento.tipo
                   }))}
                   component={renderFieldSelect}
                   label="Tipo de documento"
                   placeholder='Selecione'
                   validate={requiredSelect}/>
          </div>
          {this.props.ehRemarcacao ? <><div className="col-12 col-sm-3 col-md-3 ">
            <Field name='documentoPassegeiro' type="text" max={22} component={renderField}
                   label='Número documento com foto'
                   validate={[required]}
                   css="form-control"/>
          </div></>:
          <><div className="col-12 col-sm-3 col-md-3 ">
            <Field name='documentoPassegeiro' type="text" max={22} component={renderField}
                   label='Número documento com foto'
                   validate={[required, validarRG]}
                   css="form-control"/>
          </div></>}
        </div>
        <div className="form-row mt-1">
          {(this.props.ehRemarcacao) ? <><div className="col-12 col-sm-4 col-md-4 mt-1">
            <label>Código do País</label>
            <Field name='ddi'
              validate={requiredSelect}
              component={this.exibirComboDDI}/>
          </div>
          <div className="col-12 col-sm-6 col-md-6">
           {this.props.ddi && this.props.ddi.value == 32 ? <> {this.getTelefone()}</>: <>
              <Field name="telefone" type="text" max={15} component={renderField}
                    css="form-control col-md-6" label="Telefone"/></>}
          </div></>:
          <><div className="col-12 col-sm-4 col-md-4 mt-1">
            <label>Código do País</label>
            <Field name='ddi'
              validate={requiredSelect}
              component={this.exibirComboDDI}/>
          </div>
          <div className="col-12 col-sm-6 col-md-6">
           {this.props.ddi && this.props.ddi.value == 32 ? <> {this.getTelefone()}</>: <>
              <Field name="telefone" type="text" max={15} component={renderField}
                    validate={[required]}
                    css="form-control col-md-6" label="Telefone"/></>}
          </div></>}
        </div>
        <div className="form-row mt-1">
          <div className="col-12 col-sm-6 col-md-6"></div>
          <div className="col-12 col-sm-6 col-md-6">
            <label className="mt-2">Tipo Emissão</label>
            <Field name='tipoEmissao' validate={[requiredSelect]} alterarTipo={this.alterarTipo}
                   tiposEmissoesSelecionados={this.props.tiposEmissoesSelecionados}
                   component={this.exibirComboTipoEmissoes}/>
          </div>
        </div>
        {this.exibirCamposAdicionaisDesconto(passageiro)}
        {this.props.qtdGratuidade >= 2 ? <label style={{ color: '#ef680a' }}><strong>* Poltronas Gratuitas Esgotadas</strong></label> : ''}

        {this.props.criancaColo
          ? <div className='card mt-2 p-2'>
            <div className="form-row mt-1">
              <div className="col-md-4 col-sm-4">
              {(this.props.empresaSelecionada.habilitadoVenderCpfOpcional || !this.props.online) ? <>{!this.props.naoHabilitadoCpfPassageiro ?<Field name='cpfCrianca' type="text" component={renderFieldCpf}
                       label='Número do CPF criança'
                       validate={[required, validarCPF]} disabled={!passageiro.criancaColo}
                       css="form-control"/> : <Field name='cpfCrianca' type="text" component={renderFieldCpf}
                       label='Número do CPF criança'
                       validate={[validarCPFNaoObrigatorio]}
                       disabled={!passageiro.criancaColo}
                       css="form-control"/>}
              </>:<><Field name='cpfCrianca' type="text" component={renderFieldCpf}
                    label='Número do CPF criança'
                    validate={[required, validarCPF]} disabled={!passageiro.criancaColo}
                    css="form-control"/>
              </>}
             </div>
              <div className="col-8 col-sm-6 col-md-6">
                <Field name='nomeCrianca' type="text" component={renderField}
                       label='Nome completo da criança' validate={[required, apenasLetra]}
                       css="form-control"/>
              </div>
            </div>
            <div className="form-row mt-1">
              {this.props.ehRemarcacao ? <><div className="col-md-4 col-sm-4">
                <Field name='dtNascimentoCrianca' type="text" max={10} component={renderFieldDataNascimento}
                       label='Data de nascimento'
                       validate={[data, idadeMinCriancaColo]}
                       css="form-control"/>
              </div></>:<><div className="col-md-4 col-sm-4">
                <Field name='dtNascimentoCrianca' type="text" max={10} component={renderFieldDataNascimento}
                       label='Data de nascimento'
                       validate={[data, idadeMinCriancaColo, required]}
                       css="form-control"/>
              </div>
                </>}
              <div className="col-6 col-sm-6 col-md-6">
                <Field name='documentoCrianca' type="text" max={22} component={renderField}
                       label='Documento com foto/Certidão de nascimento'
                       validate={[required, validarRG]}
                       css="form-control"/>
              </div>
            </div>
          </div> : ''
        }

        {!this.ehGratuidadeTotal() && this.props.vendaSeguroHabilitadaNaEmpresa?
            <div className="col-12 col-sm-9 col-md-9">
              <Field name='vendaSeguro' type="checkbox" component={renderFieldCheck}
                     label="Ativar seguro ao passageiro"
                     css="form-check-input" readOnly={false}/>
            </div>
            :''}
        <Field name='criancaColo' type="checkbox" component={renderFieldCheck} label="Criança de colo"
               onChange={() => this.handleExibirCamposCrianca()}
               css="form-check-input" readOnly={false}/>

      </div>)
  }

  buscarUsuarioPorCpf (event) {
    const cpf = apenasNumero(event.target.value);
    if (cpf.length === 11) {
      this.props.buscarPassageiroPorCpf(cpf)
        .then((resp) => {
          if (resp.payload.status === 200) {
            this.props.preencherValoresParaEdicao(resp.payload.data)
          }
        })
    }
  }

  exibiValorBase () {
    const resultado = this.calcularValorTotalPassageiro();
    if (!resultado) return '';

    const { valorBase, valorCalculado, itinerarioPassageiro } = resultado;
    const valorComSeguro = Number(valorCalculado) + Number(itinerarioPassageiro.tarifaSeguro);

    return (
        <div className="col-6 col-sm-6 col-md-6">
          <label>
            Valor base {(valorBase).toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL'
          })}
          </label>
          <br/>
          {this.props.tipoEmissao && this.props.tipoEmissao.value !== 'NORMAL'
              ? <label>
                Valor passagem {(valorCalculado).toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL'
              })}
              </label>
              : ''
          }
          {!this.ehGratuidadeTotal() && this.props.vendaSeguro ?
                <label>
                  Valor com seguro {(valorComSeguro).toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL'
                })}
                </label>
              : ''
          }
        </div>
    )
  }

  render () {
    return (
      <div className="">
        {this.preencherDadosPassageiro()}
        <div className="form-group area-codigo">
          {this.exibiValorBase()}
          <Field name="codigoUsuario" type="hidden" component={renderField} css="form-control col-md-12"/>
          <Field name="opcaoDescontoMeia" type="hidden" component={renderField} css="form-control col-md-12"/>
        </div>
      </div>
    );
  }
}

export function mapStateToProps (state) {
  return {
    passageirosIda: state.passageirosIda,
    passageirosVolta: state.passageirosVolta,
    opcaoDescontoMeiaPassagem: state.opcaoDescontoMeiaPassagem,
    criancaColo: formValueSelector('formIncluirPassageiro')(state, 'criancaColo'),
    tipoEmissao: formValueSelector('formIncluirPassageiro')(state, 'tipoEmissao'),
    tipoDocumento: formValueSelector('formIncluirPassageiro')(state, 'tipoDocumento'),
    opcaoDescontoMeia: formValueSelector('formIncluirPassageiro')(state, 'opcaoDescontoMeia'),
    vendaSeguro: formValueSelector('formIncluirPassageiro')(state, 'vendaSeguro'),
    ddi: formValueSelector('formIncluirPassageiro')(state, 'ddi'),
    naoHabilitadoCpfPassageiro: formValueSelector('formIncluirPassageiro')(state, 'naoHabilitadoCpfPassageiro'),
    viagemIda: state.viagemIda,
    viagemVolta: state.viagemVolta,
    tiposDocumento: state.tiposDocumento,
    tiposEmissoesSelecionados: state.tiposEmissoesSelecionados,
    bloqueioPoltronasTemporario: state.bloqueioPoltronasTemporario,
    seForRemarcacaoDeReservaCriadoPorUsuarioSistema: state.remarcacao.reservasSelecionadasRemarcacao != null && state.remarcacao.reservasSelecionadasRemarcacao.some(it => it.foiCriadoPorUsuarioSistema),
    ehRemarcacao: state.remarcacao.reservasSelecionadas !== null,
    empresaSelecionada: state.empresaSelecionada,
    online: state.conexao.online
  }
}


export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    cadastrarReserva,
    alterarPassageiroVolta,
    alterarPassageiroIda,
    buscarPassageiroPorCpf
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formIncluirPassageiro',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(Passageiro));
